import { useNonce } from '#app/utils/nonce-provider.ts'

/**
 * Renders a JSON-LD block. Carries the CSP nonce: the site runs
 * `script-src 'strict-dynamic' 'self' 'nonce-…'`, and without it some browsers
 * will refuse the tag even though ld+json is never executed.
 */
export function StructuredData({ data }: { data: unknown | unknown[] }) {
	const nonce = useNonce()
	const blocks = Array.isArray(data) ? data.filter(Boolean) : [data].filter(Boolean)

	if (!blocks.length) return null

	return (
		<>
			{blocks.map((block, index) => (
				<script
					key={index}
					nonce={nonce}
					type="application/ld+json"
					// Content is built by our own schema helpers from CMS data, never
					// from user input. `<` is escaped so a stray value cannot close the tag.
					dangerouslySetInnerHTML={{
						__html: JSON.stringify(block).replace(/</g, '\\u003c'),
					}}
				/>
			))}
		</>
	)
}
